export default __webpack_public_path__ + "static/media/tmp_car_sketch1.3ad721b4.png";